import { render, staticRenderFns } from "./buindingRightTop.vue?vue&type=template&id=44909630&"
import script from "./buindingRightTop.vue?vue&type=script&lang=js&"
export * from "./buindingRightTop.vue?vue&type=script&lang=js&"
import style0 from "./buindingRightTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports